export class UpdateWorkspaceMetricsSettingsInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateWorkspaceMetricsSettingsInputAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "UpdateWorkspaceMetricsSettingsInputGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceMetricsSettingsInput.attributeTypeMap;
    }
    constructor() {
    }
}
